import Loadable from "components/Loadable";
import LeadBase from "pages/leads/LeadBase";
import { lazy } from "react";

const CRMPage = Loadable(lazy(() => import("pages/leads")));
const AddNewLead = Loadable(lazy(() => import("pages/leads/new-lead")));
const FollowUps = Loadable(
  lazy(() => import("pages/leads/follow-ups/FollowUps"))
);
const Sources = Loadable(lazy(() => import("pages/leads/sources/sources")));
const ProposalTemplate = Loadable(
  lazy(() => import("pages/leads/proposal-template/proposal-templates"))
);
const AddNewProposalTemplate = Loadable(
  lazy(() => import("pages/leads/proposal-template/new-proposal-template"))
);
const Proposal = Loadable(lazy(() => import("pages/leads/proposals/proposal")));
const AddNewProposal = Loadable(
  lazy(() => import("pages/leads/proposals/new-proposal"))
);
const LifeStage = Loadable(
  lazy(() => import("pages/leads/life-stage/life-stage"))
);

const CustomerList = Loadable(
  lazy(() => import("pages/contacts/customers/customers"))
);
const SupplierList = Loadable(
  lazy(() => import("pages/contacts/suppliers/suppliers"))
);
const LeadDetails = Loadable(lazy(() => import("pages/leads/Lead-Details")));
const LeadSurvey = Loadable(lazy(() => import("pages/leads/survey/survey")));
const SurveyListing = Loadable(
  lazy(() => import("pages/leads/survey/survey-listing"))
);

const CRMRoutes = {
  path: "crm",
  element: <LeadBase />,
  children: [
    {
      path: "customers",

      element: <CustomerList />,
    },
    {
      path: "supplier",

      element: <SupplierList />,
    },
    {
      path: "leads",
      // element: <LeadsList />,
      children: [
        {
          path: "",
          element: <CRMPage />,
        },
        {
          path: "new-lead",
          element: <AddNewLead />,
        },
        {
          path: "new-kanban-lead/:life_stage",
          element: <AddNewLead />,
        },
        {
          path: "edit-lead/:id",
          element: <AddNewLead />,
        },
        {
          path: "details/:id",
          element: <LeadDetails />,
        },
        {
          path: ":lead_id/survey",
          element: <LeadSurvey />,
        },
      ],
    },
    {
      path: "proposal-template",
      // element: <LeadsList />,
      children: [
        {
          path: "",
          element: <ProposalTemplate />,
        },
        {
          path: "new-proposal-template",
          element: <AddNewProposalTemplate />,
        },
        {
          path: "edit-proposal-template/:id",
          element: <AddNewProposalTemplate />,
        },
      ],
    },
    {
      path: "proposal",
      // element: <LeadsList />,
      children: [
        {
          path: "",
          element: <Proposal />,
        },
        {
          path: "new-proposal",
          element: <AddNewProposal />,
        },
        {
          path: "edit-proposal/:id",
          element: <AddNewProposal />,
        },
      ],
    },
    {
      path: "follow-ups",

      element: <FollowUps />,
    },
    {
      path: "survey",

      element: <SurveyListing />,
    },
    {
      path: "life-stage",

      element: <LifeStage />,
    },
    {
      path: "sources",

      element: <Sources />,
    },
  ],
};

export default CRMRoutes;
